import React from 'react';
import { useTranslation } from 'react-i18next';

const InvestmentUsageSection: React.FC = () => {
  const { t } = useTranslation('latvia');

  const investments = [
    {
      icon: 'ri-store-3-line',
      title: t('detail.usage.1.title'),
      description: t('detail.usage.1.desc'),
    },
    {
      icon: 'ri-shopping-basket-line',
      title: t('detail.usage.2.title'),
      description: t('detail.usage.2.desc'),
    },
    {
      icon: 'ri-truck-line',
      title: t('detail.usage.3.title'),
      description: t('detail.usage.3.desc'),
    },
    {
      icon: 'ri-team-line',
      title: t('detail.usage.4.title'),
      description: t('detail.usage.4.desc'),
    },
  ];

  return (
    <section className="py-8 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-16">
          <h2 className="text-base md:text-4xl font-bold text-gray-900 mb-1.5 md:mb-4 font-serif">
            {t('detail.usage.title')} <strong>{t('detail.usage.titleBold')}</strong> {t('detail.usage.titleEnd')}
          </h2>
          <p className="text-[10px] md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('detail.usage.description')}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 gap-2.5 md:gap-8">
          {investments.map((item, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-lg md:rounded-xl p-3 md:p-8 shadow-md md:shadow-lg hover:shadow-xl transition-all border border-gray-100 hover:border-gold-300 group"
            >
              <div className="w-8 h-8 md:w-16 md:h-16 flex items-center justify-center bg-gradient-to-br from-gold-400 to-gold-600 rounded-lg md:rounded-xl mb-2 md:mb-6 group-hover:scale-110 transition-transform">
                {/* Icon rendering – wrapped in a span to avoid JSX parsing issues */}
                <span className={`${item.icon} text-sm md:text-3xl text-white`} aria-hidden="true" />
              </div>
              <h3 className="text-xs md:text-xl font-bold text-gray-900 mb-1 md:mb-3">{item.title}</h3>
              <p className="text-[10px] leading-relaxed md:text-base text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-4 md:mt-12 bg-gradient-to-r from-gold-50 to-amber-50 rounded-lg md:rounded-2xl p-3 md:p-8 border border-gold-200">
          <div className="flex items-start">
            <div className="w-6 h-6 md:w-8 md:h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-base md:text-3xl text-gold-600" aria-hidden="true" />
            </div>
            <div className="ml-2 md:ml-4">
              <h3 className="text-xs md:text-xl font-bold text-gray-900 mb-1 md:mb-3">{t('detail.usage.commitment.title')}</h3>
              <p className="text-[10px] leading-relaxed md:text-base text-gray-700">
                {t('detail.usage.commitment.desc')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentUsageSection;